import { useCCEntity } from "components/CC/context/CCEntityContext.tsx";
import { DrawerId, FormId } from "components/CC/types/models.ts";
import { BaseConnectionCreatorDrawer } from "components/CC/UI/BaseConnectionCreatorDrawer.tsx";
import { usePaldockTranslation } from "hooks/usePaldockTranslation.tsx";

import { HttpForm } from "../Forms/HttpForm.tsx";

export const HttpDrawer = () => {
    const { formFields, customFields } = useCCEntity();
    const { t } = usePaldockTranslation("components.connection-creator");

    return (
        <BaseConnectionCreatorDrawer drawerId={DrawerId.Http} title={t("nodes.http.drawers.title")}>
            <HttpForm formId={FormId.HttpForm} formFields={formFields} customFields={customFields} />
        </BaseConnectionCreatorDrawer>
    );
};
